// extracted by mini-css-extract-plugin
export default {"tabsTitle":"Tabs_tabsTitle__GVKWM","tabsTitleIcon":"Tabs_tabsTitleIcon__UNjfR"};